import {
  ChangeDetectorRef,
  Component,
  OnChanges,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";

@Component({
    selector: "app-configure-threshold-items",
    templateUrl: "./configure-threshold-items.component.html",
    styleUrls: ["./configure-threshold-items.component.scss"],
    standalone: false
})
export class ConfigureThresholdItemsComponent implements OnInit, OnChanges {
  public editForm!: UntypedFormGroup;
  field: any;
  auto: any;

  fieldsHidden: boolean = false;
  message: string = "Are you sure?";
  private dataPointId!: number;
  name: string = "";
  type: string = "";
  typeEnding: string = "";
  typeBeginning: string = "";
  expressionName: string = "";
  public formFields: any[] = [];
  public displayRules: any;
  public filteredDisplayRules: any[] = [];

  @Input() fieldConfig: any;
  @Input() elementId: any;
  @Input() fieldData?: any;
  @Output() exportFormEvent = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder,
    private cdRef: ChangeDetectorRef
  ) {}

  exportForm(form: any) {
    const data = {
      id: this.elementId,
      form: form,
      formFields: this.formFields,
    };
    this.editForm.markAllAsTouched();
    this.exportFormEvent.emit(data);
  }

  onConfirmClick(): void {
    if (this.editForm.valid) {
      Object.keys(this.editForm.controls).forEach((key, index) => {
        if (
          this.field.filters.data[index].displayType == "toggle" ||
          this.field.filters.data[index].displayType == "button-toggle" ||
          this.field.filters.data[index].displayType == "checkbox"
        ) {
          this.field.filters.data[index].value = this.editForm
            .get(key)!
            .get("item")!.value;
        } else {
          if (this.field.filters.data[index].displayType == "number")
            this.field.filters.data[index].value = parseInt(
              this.editForm.get(key)!.value
            );
          else
            this.field.filters.data[index].value =
              this.editForm.get(key)!.value;
        }
      });
      let fieldDate: any[] = [];
      this.field.filters.data.forEach((element: any) => {
        if (element.showField) fieldDate.push(element);
      });
      this.field.filters.data = fieldDate;
    }
  }

  getaDatPointConfig(id: number) {
    const suc = JSON.parse(JSON.stringify(this.fieldConfig));
    this.name = suc.data.name;
    this.type = suc.data.type;
    if (this.type == "updated" || this.type == "created") {
      this.type = "date";
    }
    this.formFields = suc.data.filters.data;

    this.displayRules = suc.data.displayRules.data;
    this.field = suc.data;

    this.formFields.forEach((element: any, index) => {
      if (index > 0) {
        element.showField = false;
      } else {
        element.showField = true;
      }
    });
    this.typeEnding = "Operator";
    this.typeBeginning = "filterBy";
    if (
      suc.data.filters &&
      suc.data.filters.data &&
      suc.data.filters.data.length > 0
    )
      this.expressionName = suc.data.filters.data[0].name;

    this.displayRules.forEach((element: any) => {
      if (element.if == this.expressionName) {
        this.filteredDisplayRules.push(element);
      }
    });
    this.generateForm();
  }

  modifyConfigValues(event: any, name: string) {
    // reset all on change
    if (name == this.expressionName) {
      this.formFields.forEach((element: any, index) => {
        if (index > 0) {
          element.showField = false;
        } else {
          element.showField = true;
        }
      });
      this.showAssociatedFields(event.value);
    }
  }

  showAssociatedFields(val: any) {
    let fieldsToShow: any[] = [];
    this.filteredDisplayRules.forEach((element: any) => {
      if (element.containsAny.includes(val)) {
        fieldsToShow.push(element.show);
      }
    });
    this.formFields.forEach((element: any, index: any) => {
      if (fieldsToShow.includes(element.name)) {
        element.showField = true;
        this.editForm.get(element.name)?.enable();
      } else {
        element.showField = false;
        this.editForm.get(element.name)?.disable();
      }
      if (index == 0) {
        this.editForm.get(element.name)?.markAsDirty();
      } else {
        this.editForm.get(element.name)?.reset();
        this.editForm.get(element.name)?.markAsPristine();
      }
    });

    this.formFields[0].showField = true;
    this.editForm.get(this.formFields[0].name)?.enable();
  }

  setFormValues() {
    if (this.fieldData) {
      this.showAssociatedFields(this.fieldData[0].value);
      this.fieldData.forEach((element: any) => {
        if (element.value) {
          if (this.editForm.get(element.name)?.get("item")) {
            this.editForm
              .get(element.name)!
              .get("item")!
              .setValue(element.value);
            this.editForm.get(element.name)!.markAsDirty();
          } else {
            this.editForm.get(element.name)!.setValue(element.value);
            this.editForm.get(element.name)!.markAsDirty();
          }
        }
      });
    }

    /// error in here
  }

  generateField(field: any) {
    switch (field.displayType) {
      case "button-toggle":
      case "toggle":
      case "checkbox":
        if (field.value) {
          this.editForm.addControl(
            field.name,
            this.fb.group({
              item: new UntypedFormControl(field.value),
            })
          );
        } else {
          this.editForm.addControl(
            field.name,
            this.fb.group({
              item: new UntypedFormControl(field.default.data.value),
            })
          );
        }
        break;
      case "daterange":
        this.editForm.addControl(
          field.name,
          this.fb.group({
            start: new UntypedFormControl(),
            end: new UntypedFormControl(),
          })
        );
        break;
      case "datepicker":
        this.editForm.addControl(field.name, new UntypedFormControl());
        break;
      default:
        this.editForm.addControl(field.name, this.fb.control(field.value));
    }
  }

  generateForm() {
    let forEachPromise = new Promise<void>((resolve) => {
      this.formFields.forEach((field, index, array) => {
        this.generateField(field);
        if (index === array.length - 1) resolve();
      });
    });

    forEachPromise.then(() => {
      this.setFormValues();
      this.exportForm(this.editForm);
    });
  }

  ngOnChanges() {
    if (!this.editForm) {
      this.editForm = this.fb.group({});
      this.getaDatPointConfig(this.dataPointId);
    }
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {}
}
